const en = {
	"WordMenu": {
		"ReportWord": {
			"AfterClickAriaLabel": "Word reported",
			"AfterClickText": "Word reported",
			"AfterClickTitleAttribute": "Word reported",
			"AriaLabel": "Report invalid word option",
			"BeforeClickAriaLabel": "Report word option",
			"BeforeClickText": "Report word",
			"BeforeClickTitleAttribute": "Report word",
			"Text": "Report invalid word",
			"TitleAttribute": "Report invalid word"
		},
		"Definition": {
			"AriaLabel": "Read definition of {Word}",
			"Text": "Read definition",
			"TitleAttribute": "Read definition"
		},
		"MoreOptionsAriaLabel": "More options for {Word}",
		"NotSavedWordAriaLabel": "Save word option",
		"NotSavedWordText": "Save word",
		"NotSavedWordTitleAttribute": "Save word",
		"RelatedWordsAriaLabel": "See related words option",
		"RelatedWordsText": "See related words",
		"RelatedWordsTitleAttribute": "See related words",
		"RemoveAriaLabel": "Remove word option",
		"RemoveText": "Remove word",
		"RemoveTitleAttribute": "Remove word",
		"SavedWordsAriaLabel": "See saved words option",
		"SavedWordsText": "See saved words",
		"SavedWordsTitleAttribute": "See saved words"
	},
	"Wordscapes": {
		"ErrorPage": {}
	},
	"WordLists": {
		"DetailPagesInternalLinks": {
			"Text": {
				"1WordList": "5 Letter Words",
				"2WordList": "Words Containing Letters",
				"3WordList": "Words That Start With The Letter",
				"4WordList": "Words Ending In The Letter",
				"5WordList": "Words By Length",
				"6WordList": "Scrabble Cheat",
				"7WordList": "Words With Friends Cheat",
				"8WordList": "Wordle Helper"
			},
			"TitleAttribute": {
				"1WordList": "5 Letter Words",
				"2WordList": "Words Containing Letters",
				"3WordList": "Words That Start With The Letter",
				"4WordList": "Words Ending In The Letter",
				"5WordList": "Words By Length",
				"6WordList": "Scrabble Cheat",
				"7WordList": "Words With Friends Cheat",
				"8WordList": "Wordle Helper"
			},
			"Url": {
				"1WordList": "/letter-words/5/",
				"2WordList": "/words-with-the-letter/",
				"3WordList": "/words-that-start/",
				"4WordList": "/ending-with/",
				"5WordList": "/letter-words/",
				"6WordList": "/",
				"7WordList": "/words-with-friends-cheat/",
				"8WordList": "/wordle/"
			}
		},
		"IndexPageInternalLinks": {
			"Text": {
				"1GamePage": "Scrabble Cheat",
				"1WordList": "Wordle Helper",
				"2GamePage": "Words With Friends Cheat",
				"2WordList": "5 Letter Words",
				"3WordList": "Word Unscrambler",
				"4WordList": "Anagram Solver",
				"5WordList": "Words Containing Letters",
				"6WordList": "Word Maker",
				"7WordList": "Jumble Solver",
				"8WordList": "Words With Letters and a Blank",
				"Blog": "Word Games Blog"
			},
			"TitleAttribute": {
				"1GamePage": "Scrabble Cheat",
				"1WordList": "Wordle Helper",
				"2GamePage": "Words With Friends Cheat",
				"2WordList": "5 Letter Words",
				"3WordList": "Word Unscrambler",
				"4WordList": "Anagram Solver",
				"5WordList": "Words Containing Letters",
				"6WordList": "Word Maker",
				"7WordList": "Jumble Solver",
				"8WordList": "Words With Letters and a Blank",
				"Blog": "Word Games Blog"
			},
			"Url": {
				"1GamePage": "/",
				"1WordList": "/wordle/",
				"2GamePage": "/words-with-friends-cheat/",
				"2WordList": "/letter-words/5/",
				"3WordList": "/unscramble/",
				"4WordList": "/anagram-solver/",
				"5WordList": "/words-with-the-letter/",
				"6WordList": "/word-maker/",
				"7WordList": "/jumble-solver/",
				"8WordList": "/words-with-letters-blank/",
				"Blog": "/blog/"
			}
		}
	},
	"DictionaryMenu": {
		"Section": {
			"10AriaLabel": "Text Twist®",
			"10Text": "Text Twist®",
			"10TitleAttribute": "Text Twist®",
			"11AriaLabel": "CodyCross®",
			"11Text": "CodyCross®",
			"11TitleAttribute": "CodyCross®",
			"12AriaLabel": "Wordfeud",
			"12Text": "Wordfeud",
			"12TitleAttribute": "Wordfeud",
			"13AriaLabel": "WordBrain®",
			"13Text": "WordBrain®",
			"13TitleAttribute": "WordBrain®",
			"14AriaLabel": "Words Story®",
			"14Text": "Words Story®",
			"14TitleAttribute": "Words Story®",
			"15AriaLabel": "Word Swipe",
			"15Text": "Word Swipe",
			"15TitleAttribute": "Word Swipe",
			"16AriaLabel": "All Games (No Points)",
			"16Text": "All Games (No Points)",
			"16TitleAttribute": "All Games (No Points)",
			"1AriaLabel": "Words With Friends®",
			"1Text": "Words With Friends®",
			"1TitleAttribute": "Words With Friends®",
			"2AriaLabel": "Scrabble® US",
			"2Text": "Scrabble® US",
			"2TitleAttribute": "Scrabble® US",
			"3AriaLabel": "Scrabble® UK",
			"3Text": "Scrabble® UK",
			"3TitleAttribute": "Scrabble® UK",
			"4AriaLabel": "Anagram Solver",
			"4Text": "Anagram Solver",
			"4TitleAttribute": "Anagram Solver",
			"5AriaLabel": "4 Pics 1 Word®",
			"5Text": "4 Pics 1 Word®",
			"5TitleAttribute": "4 Pics 1 Word®",
			"6AriaLabel": "Jumble Solver",
			"6Text": "Jumble Solver",
			"6TitleAttribute": "Jumble Solver",
			"7AriaLabel": "Word Connect®",
			"7Text": "Word Connect®",
			"7TitleAttribute": "Word Connect®",
			"8AriaLabel": "Word Cookies!®",
			"8Text": "Word Cookies!®",
			"8TitleAttribute": "Word Cookies!®",
			"9AriaLabel": "Word Chums®",
			"9Text": "Word Chums®",
			"9TitleAttribute": "Word Chums®"
		},
		"AriaLabel": "Dictionary menu",
		"Text": "Game Dictionary: {DictionarySection}",
		"TitleAttribute": "Dictionary menu"
	},
	"Header": {
		"Section": {
			"1": {
				"Text": "Wordle Solver",
				"TitleAttribute": "Wordle Solver",
				"Url": "/wordle/"
			},
			"2": {
				"Subsection1Text": "Scrabble Dictionary",
				"Subsection1TitleAttribute": "Scrabble Dictionary",
				"Subsection1Url": "/scrabble-dictionary/",
				"Subsection2Text": "Jumble Solver",
				"Subsection2TitleAttribute": "Jumble Solver",
				"Subsection2Url": "/jumble-solver/",
				"Subsection3Text": "Anagram Solver",
				"Subsection3TitleAttribute": "Anagram Solver",
				"Subsection3Url": "/anagram-solver/",
				"Subsection4Text": "4 Pics 1 Word Answers",
				"Subsection4TitleAttribute": "4 Pics 1 Word Answers",
				"Subsection4Url": "/4pics1word/",
				"Subsection5Text": "Word Connect Cheat",
				"Subsection5TitleAttribute": "Word Connect Cheat",
				"Subsection5Url": "/word-connect-answers/",
				"Subsection6Text": "Word Cookies! Cheat",
				"Subsection6TitleAttribute": "Word Cookies! Cheat",
				"Subsection6Url": "/word-cookies/",
				"Subsection7Text": "Wordle Solver",
				"Subsection7TitleAttribute": "Wordle Solver",
				"Subsection7Url": "/wordle/",
				"Subsection8Text": "All word games helpers & tools",
				"Subsection8TitleAttribute": "All word games helpers & tools",
				"Subsection8Url": "/game-cheats/",
				"Subsection9Text": "Play Daily Crosswords",
				"Subsection9TitleAttribute": "Play Daily Crosswords",
				"Subsection9Url": "/games-and-puzzles/",
				"Text": "Words with friends <span>Cheat</span>",
				"TitleAttribute": "Words With Friends Cheat",
				"Url": "/words-with-friends-cheat/"
			},
			"3": {
				"Subsection": {
					"10Text": "Word descrambler",
					"10TitleAttribute": "Word descrambler",
					"10Url": "/word-descrambler/",
					"11Text": "Word connect answers",
					"11TitleAttribute": "Word connect answers",
					"11Url": "/word-connect-answers/",
					"12Text": "Word chums cheat",
					"12TitleAttribute": "Word chums cheat",
					"12Url": "/word-chums-cheat/",
					"13Text": "All word games helpers",
					"13TitleAttribute": "All word games helpers",
					"13Url": "/game-cheats/",
					"1Text": "Scrabble word finder",
					"1TitleAttribute": "Scrabble word finder",
					"1Url": "/",
					"2Text": "Word unscrambler",
					"2TitleAttribute": "Word unscrambler",
					"2Url": "/unscramble/",
					"3Text": "Anagram solver",
					"3TitleAttribute": "Anagram solver",
					"3Url": "/anagram-solver/",
					"4Text": "Word scramble",
					"4TitleAttribute": "Word scramble",
					"4Url": "/word-scramble/",
					"5Text": "4 pics 1 word answers",
					"5TitleAttribute": "4 pics 1 word answers",
					"5Url": "/4pics1word/",
					"6Text": "Word maker",
					"6TitleAttribute": "Word maker",
					"6Url": "/word-maker/",
					"7Text": "Jumble solver",
					"7TitleAttribute": "Jumble solver",
					"7Url": "/jumble-solver/",
					"8Text": "Words with letters and a blank",
					"8TitleAttribute": "Words with letters and a blank",
					"8Url": "/words-with-letters-blank/",
					"9Text": "Scrabble dictionary checker",
					"9TitleAttribute": "Scrabble dictionary checker",
					"9Url": "/scrabble-dictionary/"
				},
				"Text": "Word Games <span>Helpers</span>",
				"TitleAttribute": "Word Games"
			},
			"4": {
				"Subsection": {
					"10Text": "Top Searched Word Combos",
					"10TitleAttribute": "Top Searched Word Combos",
					"10Url": "/top-searched-word-combos/",
					"11Text": "Top Unscrambles",
					"11TitleAttribute": "Top Unscrambles",
					"11Url": "/top-unscrambles/",
					"12Text": "All Word Lists",
					"12TitleAttribute": "All Word Lists",
					"12Url": "/index/",
					"1Text": "Words that Contain",
					"1TitleAttribute": "Words that Contain Lists",
					"1Url": "/words-with-the-letter/",
					"2Text": "Words by Length",
					"2TitleAttribute": "Words by Length Lists",
					"2Url": "/letter-words/",
					"3Text": "Words that Start with",
					"3TitleAttribute": "Words that Start with Lists",
					"3Url": "/words-that-start/",
					"4Text": "Words Ending in",
					"4TitleAttribute": "Words Ending in Lists",
					"4Url": "/ending-with/",
					"5Text": "Vowel Words",
					"5TitleAttribute": "Vowel Words Lists",
					"5Url": "/vowels/",
					"6Text": "Words Without Vowels",
					"6TitleAttribute": "Words Without Vowels Lists",
					"6Url": "/consonants/",
					"7Text": "Words Ending in ING",
					"7TitleAttribute": "Words Ending in ING Lists",
					"7Url": "/ending-in-ing/",
					"8Text": "Q Words Without U",
					"8TitleAttribute": "Q Words Without U Lists",
					"8Url": "/q-no-u/",
					"9Text": "Popular Word Combos",
					"9TitleAttribute": "Popular Word Combos",
					"9Url": "/popular-pages/"
				},
				"Text": "Word Lists",
				"TitleAttribute": "Word Lists"
			},
			"5": {
				"Text": "Blog",
				"TitleAttribute": "Blog",
				"Url": "/blog/"
			},
			"6": {
				"Text": "Saved Words",
				"TitleAttribute": "Saved Words",
				"Url": "/saved-words/"
			},
			"AriaLabelWordscapes": "Wordscapes® Answers & Cheat",
			"TextWordscapes": "Wordscapes® Answers & Cheat",
			"TitleAttributeWordscapes": "Wordscapes® Answers & Cheat",
			"UrlWordscapes": "https://wordscapes.yourdictionary.com/"
		},
		"ArticlesIndexMetaDescription": "The best guides and strategies for all types of word games, from Wordle to crosswords. Plus, the latest news about language and word games. With interviews, in-depth research and everything you need to win at your favorite games.",
		"ArticlesIndexMetaTitle": "Tips for Words With Friends, Wordle, Scrabble and more | WordFinder®",
		"ArticlesIndexMetaTitleSubsequentPages": "Word Games Blog | WordFinder®",
		"ArticlesIndexMetaDescriptionSubsequentPages": "Tips for Words With Friends, Wordle, Scrabble and more | WordFinder®",
		"ArticlesIndexText": "Blog",
		"ArticlesIndexUrl": "/blog/",
		"EnWfText": "WordFinder",
		"EnWfUrl": "https://wordfinder.yourdictionary.com/",
		"EsWfText": "Spanish WordFinder",
		"EsWfTitleAttribute": "Spanish WordFinder Site",
		"EsWfUrl": "https://es.yourdictionary.com/buscador-de-palabras/trucos-para-apalabrados/",
		"LogoAltText": "WordFinder by YourDictionary",
		"NewDisclaimer": "NEW",
		"TextCrosswordSolver": "Crossword <span>Solver</span>",
		"TextContexto": "Contexto Answer",
		"TextPlayGames": "Play Games",
		"TextRandomWordGenerator": "Random Word Generator",
		"TextSpellingBee": "Spelling Bee Answers",
		"TextWordleAnswers": "List of Wordle Answers",
		"TextWordleHints": "Today's Wordle Answer & Hints",
		"TitleAttributeContexto": "Contexto Answer",
		"TitleAttributeCrosswordSolver": "Crossword Solver",
		"TitleAttributePlayGames": "Play Games",
		"TitleAttributeRandomWordGenerator": "Random Word Generator",
		"TitleAttributeSpellingBee": "Spelling Bee Answers",
		"TitleAttributeWordleAnswers": "List of Wordle Answers",
		"TitleAttributeWordleHints": "Today's Wordle Answer & Hints",
		"UrlContexto": "/contexto/",
		"UrlCrosswordSolver": "/crosswords/",
		"UrlPlayGames": "https://fun.yourdictionary.com/",
		"UrlRandomWordGenerator": "/random-word-generator/",
		"UrlSpellingBee": "/nyt-spelling-bee/",
		"UrlWordleAnswers": "/wordle/answers/",
		"UrlWordleHints": "/wordle/hints/",
		"YdrAriaLabel": "YourDictionary Logo",
		"YdrLogoAltText": "YourDictionary Logo",
		"YdrTitleAttribute": "YourDictionary Site",
		"YdrUrl": "https://www.yourdictionary.com/"
	},
	"LinkModule": {
		"WordsStart": {
			"1": "q",
			"2": "x",
			"3": "z",
			"4": "a",
			"5": "e",
			"6": "b",
			"7": "c",
			"8": "d",
			"9": "f",
			"10": "g",
			"11": "h",
			"12": "i",
			"13": "j",
			"14": "k",
			"15": "l",
			"16": "m",
			"17": "n",
			"18": "o",
			"19": "p",
			"20": "r",
			"21": "s",
			"22": "t",
			"23": "u",
			"24": "v",
			"25": "w",
			"26": "y",
			"Text": {
				"Template": "Words that start with <strong>{letter}</strong>"
			},
			"TitleAttribute": {
				"Template": "Words that start with {letter}"
			},
			"Url": {
				"Template": "/words-that-start/{letter}/"
			},
			"": "Words That Start With...",
			"Link": "/words-that-start/"
		},
		"WordsWith": {
			"1": "q",
			"2": "z",
			"3": "x",
			"4": "j",
			"5": "v",
			"6": "a",
			"7": "b",
			"8": "c",
			"9": "d",
			"10": "e",
			"11": "f",
			"12": "g",
			"13": "h",
			"14": "i",
			"15": "k",
			"16": "l",
			"17": "m",
			"18": "n",
			"19": "o",
			"20": "p",
			"21": "r",
			"22": "s",
			"23": "t",
			"24": "u",
			"25": "w",
			"26": "y",
			"27": "z and q",
			"28": "q and j",
			"29": "q and h",
			"30": "z and j",
			"31": "z and y",
			"32": "x and v",
			"Text": {
				"CombinationTemplate": "Words with <strong>{letter1}</strong> and <strong>{letter2}</strong>",
				"Template": "Words with the letter <strong>{letter}</strong>"
			},
			"TitleAttribute": {
				"CombinationTemplate": "Words with {letter1} and {letter2}",
				"Template": "Words with the letter {letter}"
			},
			"Url": {
				"CombinationTemplate": "/words-with-the-letter/{letter1}-and-{letter2}",
				"Template": "/words-with-the-letter/{letter}/"
			},
			"": "Words with the Letter...",
			"Link": "/words-with-the-letter/"
		},
		"WordsEnd": {
			"1": "q",
			"2": "j",
			"3": "z",
			"4": "c",
			"5": "i",
			"6": "a",
			"7": "b",
			"8": "d",
			"9": "e",
			"10": "f",
			"11": "g",
			"12": "h",
			"13": "k",
			"14": "l",
			"15": "m",
			"16": "n",
			"17": "o",
			"18": "p",
			"19": "r",
			"20": "s",
			"21": "t",
			"22": "u",
			"23": "v",
			"24": "w",
			"25": "x",
			"26": "y",
			"Text": {
				"Template": "Words that end in <strong>{letter}</strong>"
			},
			"TitleAttribute": {
				"Template": "Words that end in {letter}"
			},
			"Url": {
				"Template": "/ending-with/{letter}/"
			},
			"": "Words Ending In...",
			"Link": "/ending-with/"
		},
		"WordsNumber": {
			"1": "6",
			"2": "7",
			"3": "5",
			"4": "4",
			"5": "3",
			"6": "2",
			"7": "8",
			"8": "9",
			"9": "10",
			"10": "11",
			"11": "12",
			"12": "3 with q",
			"13": "2 with v",
			"14": "2 with q",
			"15": "3 with z",
			"16": "2 with z",
			"17": "4 with q",
			"18": "5 with q",
			"19": "4 with z",
			"20": "2 with u",
			"21": "2 with j",
			"22": "5 with x",
			"23": "3 with j",
			"24": "3 with x",
			"25": "4 with j",
			"26": "3 with v",
			"27": "5 with z",
			"28": "6 with z",
			"29": "2 with k",
			"30": "4 with x",
			"31": "6 with x",
			"Text": {
				"CombinationTemplate": "<strong>{number}</strong> letter words with <strong>{letter}</strong>",
				"Template": "<strong>{number}</strong> letter words"
			},
			"TitleAttribute": {
				"CombinationTemplate": "{number} letter words with {letter}",
				"Template": "{number} letter words"
			},
			"Url": {
				"CombinationTemplate": "/letter-words/{number}-with-{letter}",
				"Template": "/letter-words/{number}/"
			},
			"": "Words by Length...",
			"Link": "/letter-words/"
		},
		"OtherLists": {
			"": "Other Lists",
			"ExpandedText1": "<strong>Words With</strong>",
			"ExpandedText2": "<strong>Words Starting With</strong>",
			"ExpandedText3": "<strong>Words Ending In</strong>",
			"ExpandedText4": "<strong>Words By Length</strong>",
			"ExpandedText5": "Words <strong>Ending in ING</strong>",
			"ExpandedText6": "<strong>Vowel</strong> Words",
			"ExpandedText7": "Words <strong>with Q Not Followed by U</strong>",
			"ExpandedText8": "<strong>Words Without Vowels</strong>",
			"ExpandedText9": "<strong>All Lists</strong>",
			"ExpandedUrl1": "/words-with-the-letter/",
			"ExpandedUrl2": "/words-that-start/",
			"ExpandedUrl3": "/ending-with/",
			"ExpandedUrl4": "/letter-words/",
			"ExpandedUrl5": "/ending-in-ing/",
			"ExpandedUrl6": "/vowels/",
			"ExpandedUrl7": "/q-no-u/",
			"ExpandedUrl8": "/consonants/",
			"ExpandedUrl9": "/index/",
			"Text1": "Words <strong>Ending in ING</strong>",
			"Text2": "<strong>Vowel</strong> Words",
			"Text3": "<strong>Q</strong> Words <strong>Without U</strong>",
			"Text4": "<strong>Words Without Vowels</strong>",
			"TitleAttribute1": "Words Ending in ING",
			"TitleAttribute2": "Vowel Words",
			"TitleAttribute3": "Q Words Without U",
			"TitleAttribute4": "Words Without Vowels",
			"Url1": "/ending-in-ing/",
			"Url2": "/vowels/",
			"Url3": "/q-no-u/",
			"Url4": "/consonants/"
		},
		"WordsLetterAndLetter": {
			"Text1": "Words with <strong>z</strong> and <strong>q</strong>",
			"Text2": "Words with <strong>q</strong> and <strong>j</strong>",
			"Text3": "Words with <strong>q</strong> and <strong>h</strong>",
			"Text4": "Words with <strong>z</strong> and  <strong>j</strong>",
			"Text5": "Words with <strong>z</strong> and <strong>y</strong>",
			"Text6": "Words with <strong>x</strong> and <strong>v</strong>",
			"Url1": "/words-with-the-letter/z-and-q",
			"Url2": "/words-with-the-letter/q-and-j",
			"Url3": "/words-with-the-letter/q-and-h",
			"Url4": "/words-with-the-letter/z-and-j",
			"Url5": "/words-with-the-letter/z-and-y",
			"Url6": "/words-with-the-letter/x-and-v"
		},
		"SeeAllRelatedListsAriaLabel": "See All Word Lists in This Section",
		"SeeAllRelatedListsButtonText": "See All",
		"SeeLessListsAriaLabel": "See Less Word Lists in This Section",
		"SeeLessListsButtonText": "See Less"
	},
	"Login": {
		"Button": {
			"AriaLabelHeaderGetStarted": "Sign In button",
			"AriaLabelSignIn": "Log in with Google",
			"AriaLabelSignUp": "Sign up with Google",
			"TextHeaderGetStarted": "Sign In",
			"TextHeaderSignIn": "Log in",
			"TextSignIn": "Log in with Google",
			"TextSignUp": "Sign in with Google",
			"TitleAttributeHeaderGetStarted": "Sign In",
			"TitleAttributeSignIn": "Log in with Google",
			"TitleAttributeSignUp": "Sign in with Google"
		},
		"Dialog": {
			"LegalDisclaimerSignIn": "Click 'Log in with Google' to accept YourDictionary's <a href='https://www.yourdictionary.com/about/terms-of-use.html' target='_blank'>Terms of Use</a> and <a href=' ' target='_blank'>Privacy Policy</a>.",
			"LegalDisclaimerSignUp": "Click 'Sign in with Google' to accept YourDictionary's <a href='https://www.yourdictionary.com/about/terms-of-use.html' target='_blank'>Terms of Use</a> and <a href='https://www.yourdictionary.com/about/privacy.html' target='_blank'>Privacy Policy</a>.",
			"Text1SignIn": "Log in to save more words and access personalized features.",
			"Text1SignUp": "Sign in to get our newsletter and never lose the words you save",
			"Text2SignUp": "Already have an account?",
			"Text3SignUp": "Remind me later",
			"TextSignIn": "No account?",
			"TitleSignIn": "Welcome Back, Vocabulist!",
			"TitleSignUp": "Welcome, Vocabulist!"
		},
		"Menu": {
			"TextSavedWords": "My Saved Words",
			"TextSignOut": "Sign Out",
			"TextUserEmail": "{GmailEmail}",
			"TextUsername": "{GmailUserName}",
			"TitleAttributeSavedWords": "My Saved Words",
			"TitleAttributeSignOut": "Sign Out",
			"UrlSavedWords": "/saved-words/",
			"UrlSignOut": "Sign Out"
		}
	},
	"ReportWord": {
		"Dialog": {
			"CancelButton": "Cancel",
			"CancelTitleAttribute": "Cancel",
			"CloseButton": "Close",
			"CloseTitleAttribute": "Close",
			"ReportButton": "Report",
			"ReportTitleAttribute": "Report",
			"SelectGameTitleText": "Your Word Game",
			"SelectGameTooltipText": "Knowing the game you’re playing helps us take care of the reported word.",
			"TitleText": "Report a Word",
			"UserReportedThanksText": "Your feedback will help a lot of game players!",
			"UserReportedThanksTitleText": "Thank You!",
			"UserReportedWordTitleText": "Invalid Word"
		},
		"MenuGame": {
			"10AltText": "Wordfeud App Thumbnail",
			"10AriaLabel": "Wordfeud",
			"10Text": "Wordfeud",
			"10TitlteAttribute": "Wordfeud",
			"11AltText": "Word Swipe App Thumbnail",
			"11AriaLabel": "Word Swipe",
			"11Text": "Word Swipe",
			"11TitlteAttribute": "Word Swipe",
			"1AltText": "Words With Friends® App Thumbnail",
			"1AriaLabel": "Words With Friends® option",
			"1Text": "WWF",
			"1TitlteAttribute": "Words With Friends®",
			"2AltText": "Scrabble App Thumbnail",
			"2AriaLabel": "Scrabble",
			"2Text": "Scrabble",
			"2TitlteAttribute": "Scrabble",
			"3AltText": "Word Chums® App Thumbnail",
			"3AriaLabel": "Word Chums®",
			"3Text": "Word Chums®",
			"3TitlteAttribute": "Word Chums®",
			"4AltText": "Word Domination App Thumbnail",
			"4AriaLabel": "Word Domination",
			"4Text": "Word Domination",
			"4TitlteAttribute": "Word Domination",
			"5AltText": "Word Connect® App Thumbnail",
			"5AriaLabel": "Word Connect®",
			"5Text": "Word Connect®",
			"5TitlteAttribute": "Word Connect®",
			"6AltText": "Wordscapes® App Thumbnail",
			"6AriaLabel": "Wordscapes®",
			"6Text": "Wordscapes®",
			"6TitlteAttribute": "Wordscapes®",
			"7AltText": "Word Cookies!® App Thumbnail",
			"7AriaLabel": "Word Cookies!®",
			"7Text": "Word Cookies!®",
			"7TitlteAttribute": "Word Cookies!®",
			"8AltText": "4 Pics 1 Word® App Thumbnail",
			"8AriaLabel": "4 Pics 1 Word®",
			"8Text": "4 Pics 1 Word®",
			"8TitlteAttribute": "4 Pics 1 Word®",
			"9AltText": "Words Story® App Thumbnail",
			"9AriaLabel": "Words Story®",
			"9Text": "Words Story®",
			"9TitlteAttribute": "Words Story®"
		},
		"MenuOtherGameAriaLabel": "Other games",
		"MenuOtherGameText": "Other games",
		"MenuOtherGameTitleAttribute": "Other games"
	},
	"SavedWords": {
		"Page": {
			"Body": "A list of saved words can help you increase your vocabulary and investigate definitions, related forms, and much more at your own pace. You can add and remove words from your saved words list at any time, and there is no word limit. May the words be with you...!",
			"H1": "Saved Words",
			"LoginH1": "My Saved Words",
			"LoginTooltip": "Click on the menu button in each row {icon} to manage your Saved Words.",
			"MetaDescription": "Save your favorite words or new terms that you just discovered. Check out definitions and related words, and remove words from your list at any time.",
			"MetaTitle": "Your Saved Words: Create Your Own Word List!",
			"TableButtonText": "Save a Bonus Word",
			"TableButtonTitleAttribute": "Save a Bonus Word",
			"TableButtonUrl": "/",
			"TableDateColumn": "Date",
			"TableDateColumnDesktop": "{MM/DD/YY}",
			"TableDateColumnMobile": "{MM/YY}",
			"TableDefaultWord1": "Numinous",
			"TableDefaultWord2": "Wo",
			"TableDefaultWord3": "Discombobulate",
			"TableLeftVerticalColumn": "Saved Words",
			"TableLengthColumn": "Length",
			"TableTooltip": "<ul><li>Manage your own words by clicking on the three-dots menu {icon} in each word row.</li><li>If you clear all your browsing data, your list will disappear.</li></ul>",
			"TableWordColumn": "Word"
		},
		"Breadcrumb": "SAVED WORDS",
		"ModuleBeforeWordSavedText": "You haven't saved any words yet.<br>To save words, use the three-dots menu ([icon]) that you will find in each word row and select the <italic>Save word</italic> option.",
		"Url": "/saved-words/"
	},
	"ScrabbleDictionaryResults": {
		"InternalLinks": {
			"Text": {
				"1GamePage": "Words With Friends® Cheat",
				"1WordList": "Words with",
				"2GamePage": "Unscramble Words",
				"2WordList": "Words that Start with",
				"3WordList": "Words Ending in",
				"4WordList": "Words by Length",
				"5WordList": "Vowel Words",
				"6WordList": "Words Without Vowels",
				"7WordList": "Q Words Without U",
				"8WordList": "Words Ending in ING",
				"Blog": "WordFinder Blog"
			},
			"TitleAttribute": {
				"1GamePage": "Words With Friends® Cheat",
				"1WordList": "Words with Lists",
				"2GamePage": "Unscramble Words",
				"2WordList": "Words that Start with Lists",
				"3WordList": "Words Ending in Lists",
				"4WordList": "Words by Length Lists",
				"5WordList": "Vowel Words List",
				"6WordList": "Words Without Vowels List",
				"7WordList": "Q Words Without U List",
				"8WordList": "Words Ending in ING List",
				"Blog": "WordFinder Blog"
			},
			"Url": {
				"1GamePage": "/words-with-friends-cheat/",
				"1WordList": "/words-with-the-letter/",
				"2GamePage": "/unscramble/",
				"2WordList": "/words-that-start/",
				"3WordList": "/ending-with/",
				"4WordList": "/letter-words/",
				"5WordList": "/vowels/",
				"6WordList": "/consonants/",
				"7WordList": "/q-no-u/",
				"8WordList": "/ending-in-ing/",
				"Blog": "/blog/"
			}
		},
		"H1": "Scrabble Dictionary",
		"H2InvalidWord": "is not playable",
		"H2ValidWord": "is playable",
		"H3OtherWords": "Other Scrabble Words with {UserQuery}",
		"H3OtherWordsAndWildcard": "Other Scrabble Words with {UserQuery} and Another Letter",
		"MetaDescription": "Is {query} a playable Scrabble word? Quickly check whether your play is valid with our Scrabble dictionary, complete how many points it's worth.",
		"MetaTitle": "Is {Query} a Scrabble Word? | WordFinder® Scrabble Dictionary",
		"TextDictionarySection": "Most popular games",
		"TitleAttributeYourDictionary": "See full definition by YourDictionary."
	},
	"UnscrambleResults": {
		"InternalLinks": {
			"Text": {
				"1GamePage": "Scrabble Cheat",
				"1WordList": "Wordle Helper",
				"2GamePage": "Words With Friends Cheat",
				"2WordList": "5 Letter Words",
				"3WordList": "Word Unscrambler",
				"4WordList": "Anagram Solver",
				"5WordList": "Words Containing Letters",
				"6WordList": "Word Maker",
				"7WordList": "Jumble Solver",
				"8WordList": "Words With Letters and a Blank",
				"Blog": "Word Games Blog"
			},
			"TitleAttribute": {
				"1GamePage": "Scrabble Cheat",
				"1WordList": "Wordle Helper",
				"2GamePage": "Words With Friends Cheat",
				"2WordList": "5 Letter Words",
				"3WordList": "Word Unscrambler",
				"4WordList": "Anagram Solver",
				"5WordList": "Words Containing Letters",
				"6WordList": "Word Maker",
				"7WordList": "Jumble Solver",
				"8WordList": "Words With Letters and a Blank",
				"Blog": "Word Games Blog"
			},
			"Url": {
				"1GamePage": "/",
				"1WordList": "/wordle/",
				"2GamePage": "/words-with-friends-cheat/",
				"2WordList": "/letter-words/5/",
				"3WordList": "/unscramble/",
				"4WordList": "/anagram-solver/",
				"5WordList": "/words-with-the-letter/",
				"6WordList": "/word-maker/",
				"7WordList": "/jumble-solver/",
				"8WordList": "/words-with-letters-blank/",
				"Blog": "/blog/"
			}
		},
		"H1": "Unscramble {UserQuery}",
		"H1NoResultsAndAndWildcards": "There Are 0 Results. Showing Words with {UserQuery} and Wildcards",
		"H1NoResultsAndWildcard": "There Are 0 Results. Showing Words with {UserQuery} and Wildcards",
		"H1WordsAndWildcard": "Words with {UserQuery} and Another Letter",
		"H1WordsAndWildcards": "Words with {UserQuery} and Other Letters",
		"H2OtherWordsAndWildcard": "Other Words with {UserQuery} and Another Letter",
		"H2OtherWordsAndWildcards": "Other Words with {UserQuery} and Other Letters",
		"MetaDescriptionText": "Unscramble {UserQuery} for cheat answers from the Scrabble and Words With Friends official word lists. Click here to find {numberQuery} words with {UserQuery} for free.",
		"MetaTitleText": "Unscramble {UserQuery} | {numberQuery} Words With the Letters {UserQuery}"
	},
	"WordsContains": {
		"EndsDetailPage": {
			"H1": "Words Containing {ContainQuery} and Ending in {EndQuery}",
			"MetaDescription": "Find all words with {ContainQuery} & ending in {EndQuery}. Get a complete word list with {ContainQuery} & {EndQuery} to score more points in Scrabble, Words With Friends and all your favorite word games. ",
			"MetaTitle": "Words With {ContainQuery} & Ending in {EndQuery} | WordFinder®",
			"TableHeadingWordLength": "{numberQuery} Letter Words Containing {ContainQuery} and Ending in {EndQuery}",
			"Text": "<strong>Words with {ContainQuery} that end in {EndsQuery}</strong> are exactly what you need to win your next game of Words With Friends®, Scrabble® or help you solve a difficult crossword puzzle clue. This complete word list is organized by total points or alphabetically, making it easy to find the word you need, whether they are {ContainLink} or {EndsLink}.",
			"Url": "https://wordfinder.yourdictionary.com/words-with-the-letter/with-VALUE-ends-VALUE/"
		},
		"EndsLengthDetailPage": {
			"H1": "{numberQuery} Letter Words Containing {ContainQuery} and Ending in {EndQuery}",
			"MetaDescription": "Find all {numberQuery} letter words with {ContainQuery} & ending in {EndQuery}. Get customized {ContainQuery} & {EndQuery} word lists with {numberQuery} letters that will lead you to victory in Words With Friends and Scrabble.",
			"MetaDescriptionWithWordle": "Uncover all the 5-letter words with {ContainQuery} & ending in {EndQuery} for Wordle, Words With Friends and more. Win every game with the right list of five-letter {ContainQuery} & {EndQuery} words. ",
			"MetaTitle": "{numberQuery} Letter Words With {ContainQuery} & Ending in {EndQuery} | WordFinder®",
			"TableHeadingWordLength": "{numberQuery} Letter Words Containing {ContainQuery} and Ending in {EndQuery}",
			"Text": "<strong>{LengthQuery} letter words with {ContainQuery} that end in {EndsQuery}</strong> are fantastic for landing those big winning plays in your favorite word games, whether it's Words With Friends® or Scrabble®. Unleash those double or triple word scores by playing valuable {ContainLink} and {EndsLink}.",
			"TextWithWordle": "<strong>Five letter words containing {ContainQuery} that end in {EndsQuery}</strong> could be the <a href='/wordle/'>Wordle help</a> you need to solve today's puzzle. This {LengthLink} list is also fantastic for landing big scoring plays in Words With Friends®, Scrabble® GO and other word games too. Get *{ContainQuery}*{EndsQuery} words to win in your chosen game.",
			"Url": "https://wordfinder.yourdictionary.com/letter-words/NUMBER-with-VALUE-ends-VALUE/"
		},
		"LengthDetailPage": {
			"H1": "{numberQuery} Letter Words Containing {ContainQuery}",
			"MetaDescription": "Find all {numberQuery} letter words with {ContainQuery}. Discover custom {ContainQuery} word lists with {numberQuery} letters to win at Scrabble, Words With Friends and more word games. Complete with points!",
			"MetaDescriptionWithWordle": "These 5-letter words with {ContainQuery} will help you solve the daily Wordle and win in Words With Friends. Find a complete five-letter word list containing {ContainQuery} here.",
			"MetaTitle": "{numberQuery} Letter Words With {ContainQuery} | WordFinder®",
			"TableHeadingWordLength": "{numberQuery} Letter Words Containing {ContainQuery}",
			"Text": "<strong>{LengthQuery} letter words with {ContainQuery}</strong> are exactly what you need to win your game of Words With Friends®. We've got the complete Scrabble® US and UK word lists too. Get all the {ContainLink} and {LengthLink} you want to find, including {LengthStartsLink} and {LengthEndsLink}.",
			"TextWithWordle": "<strong>Five letter words with {ContainQuery}</strong> are useful when you want to <a href='/wordle/'>solve Wordle</a> every day. A comprehensive list of 5 letter words containing {ContainQuery} can help you find top scoring words in Scrabble® and Words With Friends® too. Check the definitions and save your favorite words! For more options, check out {LengthStartsLink} and {LengthEndsLink}.",
			"Url": "https://wordfinder.yourdictionary.com/letter-words/NUMBER-with-VALUE/"
		}
	},
	"WordsStarts": {
		"Contains": {
			"DetailPage": {
				"H1": "Words Starting with {StartQuery} and Containing {ContainQuery}",
				"MetaDescription": "Find all words starting with {StartQuery} & containing {ContainQuery}. Get the winning word list with {StartQuery} & {ContainQuery} to win at Scrabble, Words With Friends and more, complete with points!",
				"MetaTitle": "Words Starting With {StartQuery} & Containing {ContainQuery} | WordFinder®",
				"TableHeadingWordLength": "{numberQuery} Letter Words Starting with {StartQuery} and Containing {ContainQuery}",
				"Text": "<strong>Words that start with {StartsQuery} and contain {ContainQuery}</strong> are all here. Make the most of the tiles in your rack and the letters already played on the board to score big in Words With Friends® and Scrabble®. Find {ContainLink} and {StartsLink} to reach that double or triple word bonus and win!",
				"Url": "https://wordfinder.yourdictionary.com/words-with-the-letter/starts-VALUE-with-VALUE/"
			},
			"EndsDetailPage": {
				"H1": "Words Starting with {StartQuery}, Containing {ContainQuery} and Ending in {EndQuery}",
				"MetaDescription": "Find all words starting with {StartQuery}, containing {ContainQuery} & ending in {EndQuery}. Score using a winning word list with {StartQuery}, {ContainQuery} and {EndQuery} for Scrabble, Words With Friends and other games. ",
				"MetaTitle": "Words Starting With {StartQuery}, Containing {ContainQuery} & Ending in {EndQuery} | WordFinder®",
				"TableHeadingWordLength": "{numberQuery} Letter Words Starting with {StartQuery}, Containing {ContainQuery} and Ending in {EndQuery}",
				"Text": "<strong>Words that start with {StartsQuery}, contain {ContainQuery} and end in {EndsQuery}</strong> can be really specific, like you'd need when you're stumped by a crossword clue. Fear not! Leave it up to us at WordFinder to find all the {StartsLink}, {ContainLink} or {EndsLink} you want for every word game situation, from Words With Friends® to Wordscapes® and more.",
				"Url": "https://wordfinder.yourdictionary.com/words-with-the-letter/starts-VALUE-with-VALUE-ends-VALUE/"
			},
			"LengthDetailPage": {
				"H1": "{numberQuery} Letter Words Starting with {StartQuery} and Containing {ContainQuery}",
				"MetaDescription": "Find all {numberQuery} letter words starting with {StartQuery} & containing {ContainQuery}. Turn here for custom {StartQuery} & {ContainQuery} word lists with {numberQuery} letters to win at Scrabble, Words With Friends and more. ",
				"MetaDescriptionWithWordle": "Solve Wordle with 5-letter words starting with {StartQuery} & containing {ContainQuery}. When you've got five-letter {StartQuery} words with {ContainQuery}, word game success is yours for the taking. ",
				"MetaTitle": "{numberQuery} Letter Words Starting With {StartQuery} & Containing {ContainQuery} | WordFinder®",
				"TableHeadingWordLength": "{numberQuery} Letter Words Starting with {StartQuery} and Containing {ContainQuery}",
				"Text": "<strong>{LengthQuery} letter words that start with {StartsQuery} and contain {ContainQuery}</strong> can set you on the path to victory in word games like Scrabble® or Words With Friends®. Word lists exactly like these {LengthLink} are only a few quick finger taps away on WordFinder®. Dive into {StartsLink} or {ContainLink} to find your next super high-scoring play.",
				"TextWithWordle": "<strong>Five letter words beginning with {StartsQuery} and containing {ContainQuery}</strong> can help you <a href='/wordle/'>solve today's Wordle</a>. Specific word lists like this are here so you can score big points in Scrabble® GO and Words With Friends® too. Get the full {LengthLink} list including {StartsQuery} words to jump at every opportunity and win every game.",
				"Url": "https://wordfinder.yourdictionary.com/letter-words/NUMBER-starts-VALUE-with-VALUE/"
			},
			"EndsLengthDetailPageH1": "{numberQuery} Letter Words Starting with {StartQuery}, Containing {ContainQuery} and Ending in {EndQuery}",
			"EndsLengthDetailPageMetaDescription": "Find all {numberQuery} letter words starting with {StartQuery}, containing {ContainQuery} and ending in {EndQuery}. Make the most of any word game using a {numberQuery}-letter word list with {StartQuery}, {ContainQuery} and {EndQuery} to win.",
			"EndsLengthDetailPageMetaDescriptionWithWordle": "This list of 5-letter words starting with {StartQuery}, containing {ContainQuery} & ending in {EndQuery} is the Wordle help you need to win. Find every five-letter word using {StartQuery}, {ContainQuery} & {EndQuery}.",
			"EndsLengthDetailPageMetaTitle": "{numberQuery} Letter Words Starting with {StartQuery}, Containing {ContainQuery} & Ending in {EndQuery} | WordFinder®",
			"EndsLengthDetailPageTableHeadingWordLength": "{numberQuery} Letter Words Starting with {StartQuery}, Containing {ContainQuery} and Ending in {EndQuery}",
			"EndsLengthDetailPageText": "<strong>{LengthQuery} letter words that start with {StartsQuery}, contain {ContainQuery} and end in {EndsQuery}</strong> allow you to unearth the highest scoring plays in Scrabble® GO or Words With Friends®. We've made it as easy as possible for you to find exactly what you need, including {LengthStartsLink} and {LengthEndsLink}.",
			"EndsLengthDetailPageTextWithWordle": "<strong>Five letter words beginning with {StartsQuery}, containing {ContainQuery}, and ending in {EndsQuery}</strong> take full advantage of the advanced search features here on WordFinder. And who can blame you? Get all the <a href='/wordle/'>Wordle help</a> you want and find the winning words you need for Scrabble® GO or Words With Friends®. These {LengthStartsLink} will set you on the path to victory.",
			"EndsLengthDetailPageUrl": "https://wordfinder.yourdictionary.com/letter-words/NUMBER-starts-VALUE-contains-VALUE-ends-VALUE/"
		},
		"Ends": {
			"DetailPage": {
				"H1": "Words Starting with {StartQuery} and Ending in {EndQuery}",
				"MetaDescription": "Find all words starting with {StartQuery} & ending in {EndQuery}. Get the ultimate word list with {StartQuery} & {EndQuery} to win at Scrabble and Words With Friends, complete with points. Score!",
				"MetaTitle": "Words Starting With {StartQuery} & Ending in {EndQuery} | WordFinder®",
				"TableHeadingWordLength": "{numberQuery} Letter Words Starting with {StartQuery} and Ending in {EndQuery}",
				"Text": "<strong>Words that start with {StartsQuery} and end in {EndsQuery}</strong> will help you land the highest-scoring word when you're playing a word game, like Words With Friends® or Scrabble® GO. We are here to provide you with {StartsLink} and {EndsLink}, organized alphabetically or by total points.",
				"Url": "https://wordfinder.yourdictionary.com/words-with-the-letter/starts-VALUE-ends-VALUE/"
			},
			"LengthDetailPage": {
				"H1": "{numberQuery} Letter Words Starting with {StartQuery} and Ending in {EndQuery}",
				"MetaDescription": "Find all {numberQuery} letter words starting with {StartQuery} and ending in {EndQuery}. Find the right combo and beat any word game with our {StartQuery} and {EndQuery} {numberQuery}-letter word list, with points too!",
				"MetaDescriptionWithWordle": "A complete list of 5-letter words that start with {StartQuery} & end in {EndQuery} is what you need to solve today's Wordle. Get all the five-letter {StartQuery} words ending in {EndQuery} here.",
				"MetaTitle": "{numberQuery} Letter Words Starting With {StartQuery} & Ending in {EndQuery} | WordFinder®",
				"TableHeadingWordLength": "{numberQuery} Letter Words Starting with {StartQuery} and Ending in {EndQuery}",
				"Text": "<strong>{LengthQuery} letter words that start with {StartsQuery} and end in {EndsQuery}</strong> are exactly what you need whether you're working on a crossword puzzle or challenging your friends in a rousing game of Scrabble® or Words With Friends®. That's where our powerful word finder comes into play. You may also want to check out {LengthStartsLink} or {LengthEndsLink}.",
				"TextWithWordle": "<strong>Five letter words beginning with {StartsQuery} that end in {EndsQuery}</strong> narrow down the possible plays in <a href='/wordle/'>Wordle</a> so you get those green squares. {StartsQuery} words ending in {EndsQuery} are great for a rousing game of Scrabble® or Words With Friends® too. Hit those bonus squares with the best 5 letter words. For more, check out {LengthStartsLink} and {LengthEndsLink}.",
				"Url": "https://wordfinder.yourdictionary.com/letter-words/NUMBER-starts-VALUE-ends-VALUE/"
			}
		},
		"LengthDetailPage": {
			"H1": "{numberQuery} Letter Words Starting with {StartQuery}",
			"MetaDescription": "Find all {numberQuery} letter words starting with {StartQuery}. Win with a list of {StartQuery} words that are {numberQuery} letters long in Scrabble, Words With Friends and more. Complete with points!",
			"MetaDescriptionWithWordle": "Find 5-letter words starting with {StartQuery} to solve today's Wordle. This full list of {StartQuery} words with five letters paves the path to victory in Words With Friends too.",
			"MetaTitle": "{numberQuery} Letter Words Starting With {StartQuery} | WordFinder®",
			"TableHeadingWordLength": "{numberQuery} Letter Words Starting with {StartQuery}",
			"Text": "<strong>{LengthQuery} letter words that start with {StartsQuery}</strong> aren't so tough to find when you have WordFinder by your side. As you consider your options for your next play in Words With Friends® or Scrabble® GO, take a look at how these {LengthLink} and {StartsLink} can fit best on your game board. You may also want to check out {LengthContainLink} and {LengthEndsLink}.",
			"TextWithWordle": "<strong>Five letter words beginning with {StartsQuery}</strong> are exactly what you need as a daily <a href='/wordle/'>Wordle solver</a>. Plus, when you're playing word games like Scrabble® and Words With Friends®, you can find the best 5 letter words that start with {StartsQuery} to score the most points and defeat your opponent. Capitalize on every opportunity with {LengthContainLink} and {LengthEndsLink} too.",
			"Url": "https://wordfinder.yourdictionary.com/letter-words/NUMBER-starts-VALUE/"
		}
	},
	"AdvancedSearch": {
		"ButtonAriaLabel": "Advanced search button",
		"ButtonTextA": "Advanced Search",
		"ButtonTextB": "Advanced Search",
		"ButtonTitleAttribute": "Advanced search",
		"CollapseButtonText": "Hide",
		"ContainsAriaLabel": "Contains Letter Search Field",
		"ContainsText": "Contains",
		"ContainsTooltip": "See words that contain these letters in this order (AS &rarr; Astray) or in certain positions (A_S &rarr; Ye<strong>a</strong>r<strong>s</strong>)",
		"ContainsTooltipAriaLabel": "Contains search field tooltip",
		"EndsText": "Ends in",
		"EndsTextB": "Ends",
		"EndsTooltip": "See words that <strong>end</strong> in these letters (AS &rarr; Are<strong>as</strong>)",
		"EndsTooltipAriaLabel": "Ends with search field tooltip",
		"EndsWithAriaLabel": "Ends With Letter Search Field",
		"LengthErrorText": "Value must be between 2 and 20.",
		"LengthText": "Length",
		"LengthTitleAttribute": "Length",
		"LengthTooltip": "See words that have a <strong>specific word length</strong>",
		"LengthTooltipAriaLabel": "See words that have a specific word length",
		"SecondLevelSearchButtonText": "Search",
		"SecondLevelSearchButtonTitleAttribute": "Search",
		"StartsText": "Starts with",
		"StartsTextB": "Starts",
		"StartsTooltip": "See words that <strong>start</strong> with these letters (AS &rarr; <strong>As</strong>sert)",
		"StartsTooltipAriaLabel": "Starts with search field tooltip",
		"StartsWithAriaLabel": "Starts With Letter Search Field",
		"Text": "Advanced Search"
	},
	"Article": {
		"PromoModuleH2": "Latest Articles",
		"PromoModuleSeeAllButton": "See All Articles",
		"PromoModuleSeeAllTitleAttribute": "Latest Articles",
		"sIndexPageAllArticlesH2": "All Articles",
		"sIndexPageH1": "Word Games Blog",
		"sIndexPageLatestArticlesH2": "See more popular articles",
		"sIndexPageReadingTime": "min read"
	},
	"Breadcrumb": {
		"ArticlePage": "Article",
		"ArticlesIndex": "Blog",
		"HomeText": "Word Finder",
		"WordsByNumberIndexText": "Words By Length",
		"WordsByNumberIndexUrl": "/letter-words/",
		"WordsEndingIndexText": "Words Ending In",
		"WordsEndingIndexUrl": "/ending-with/",
		"WordsStartingIndexText": "Words That Start With",
		"WordsStartingIndexUrl": "/words-that-start/",
		"WordsWithIndexText": "Words With The Letter",
		"WordsWithIndexUrl": "/words-with-the-letter/"
	},
	"CcpaPage": {},
	"ClearButton": {
		"AriaLabel": "Clear button",
		"ContainsResultsAriaLabel": "Contains clear button",
		"ContainsResultsTitleAttribute": "Contains clear button",
		"EndsResultsAriaLabel": "Ends clear button",
		"EndsResultsTitleAttribute": "Ends clear button",
		"LengthResultsAriaLabel": "Clear button",
		"StartsResultsAriaLabel": "Starts clear button",
		"StartsResultsTitleAttribute": "Starts clear button",
		"TitleAttribute": "Clear button"
	},
	"ErrorPage": {
		"BodyText": "The page you're looking for doesn't exist.",
		"H1": "We ran out of words",
		"MetaDescription": "Sorry, this page can't be found.",
		"MetaTitle": "Sorry, this page can't be found.",
		"ReadBlogButtonAriaLabel": "Read the Blog",
		"ReadBlogButtonText": "Read the Blog",
		"ReadBlogButtonTitleAttribute": "Read the Blog",
		"ReadBlogButtonUrl": "/blog/",
		"SearchWordsButtonAriaLabel": "Find words button",
		"SearchWordsButtonText": "Find Words",
		"SearchWordsButtonTitleAttribute": "Find Words",
		"SearchWordsButtonUrl": "/",
		"SeeWordListsButtonAriaLabel": "See word lists button",
		"SeeWordListsButtonText": "See Word Lists",
		"SeeWordListsButtonTitleAttribute": "See Word Lists",
		"SeeWordListsButtonUrl": "/index/"
	},
	"Footer": {
		"ButtonTitleAttributeAppStore": "Download on the App Store",
		"ButtonTitleAttributeGooglePlay": "Get It on Google Play ",
		"CcpaText": "Do not sell my personal information",
		"CcpaTitleAttribute": "Do not sell my personal information",
		"CcpaUrl": "https://privacyportal.onetrust.com/webform/48e006e6-e02c-4bd4-a8ea-1f20b08c40ee/ddd666be-6e99-4ea6-8ba7-6d20bf6465cf",
		"CompanyText": "ABOUT YOURDICTIONARY",
		"CompanyUrl": "https://www.yourdictionary.com/about.html",
		"ContactText": "CONTACT US",
		"ContactUrl": "https://www.yourdictionary.com/about/contact.html",
		"PrivacyPolicyText": "PRIVACY POLICY",
		"PrivacyPolicyUrl": "https://www.yourdictionary.com/about/privacy.html",
		"SuggestionsText": "SUGGESTION BOX",
		"SuggestionsUrl": "https://www.surveymonkey.com/r/7ZWK2J6",
		"TextDownloadApp": "Download the App"
	},
	"Gdpr": {
		"BannerAllowCookiesButton": "Got it!",
		"BannerLearnMoreButton": "Learn more",
		"BannerLearnMoreUrl": "https://www.yourdictionary.com/about/cookie.html",
		"BannerLegalText": "This website uses cookies to ensure you get the best experience."
	},
	"Results": {
		"PointsText": "Points",
		"SortAlphabeticalText": "A to Z",
		"SortAlphabeticalTitleAttribute": "A to Z",
		"SortInverseAlphabeticalText": "Z to A",
		"SortInverseAlphabeticalTitleAttribute": "Z to A",
		"SortPointsText": "Points",
		"SortPointsTitleAttribute": "Points",
		"SortPopularityText": "Popularity",
		"SortPopularityTitleAttribute": "Popularity",
		"SortText": "Sort by",
		"SortTextMobileAndTablet": "Sort",
		"WordsEndTableTitle": "{numberQuery} Letter Words That End in {letterQuery}",
		"WordsLetterAndLetterTableTitle": "{numberQuery} Letter Words with {letterQuery}",
		"WordsNumberAndLetterTableTitle": "{numberQuery} Letter Words with {letterQuery}",
		"WordsNumberTableTitle": "{numberQuery} Letter Words",
		"WordsStartTableTitle": "{numberQuery} Letter Words That Start with {letterQuery}",
		"WordsText": "Words",
		"WordsWithTableTitle": "{numberQuery} Letter Words That Contain {letterQuery}"
	},
	"Scrabble": {
		"DictionaryFirstH2": "WordFinder Scrabble Dictionary"
	},
	"Search": {
		"BoxAnagramSolverEmptyText": "ENTER LETTERS",
		"BoxAriaLabel": "Search Bar",
		"BoxBoardLettersTooltipText": "Improve your search results by adding letters in the advanced search",
		"BoxBoardLettersTooltipTextB": "You can improve your search results with any of the fields below",
		"BoxErrorAlphabet": "Only letters and ? characters are allowed",
		"BoxErrorCharacters": "Enter at least two letters in the search bar",
		"BoxErrorWildcard": "You can only use up to 3 wildcards (? or space bar)",
		"BoxGameEmptyText": "ENTER LETTERS",
		"BoxWildcardText": "Enter up to 3 wildcards (? or space)",
		"BoxWildcardTextWordle": "Enter letters in one or both fields",
		"ButtonAriaLabel": "Search button",
		"ButtonTitleAttribute": "Search button",
		"SubsectionTextAllDictionariesNoPoints": "All Games",
		"SubsectionTextAllDictionariesNoPointsDesktop": "All Games",
		"SubsectionTextAllScrabbleMobile": "All Scrabble®",
		"SubsectionTextWWFMobile": "WWF"
	},
	"Unscramble": {
		"ApplyFiltersButtonText": "Apply",
		"ApplyFiltersButtonTitleAttribute": "Apply",
		"DictionaryH2": "Game Dictionary",
		"FilterScreenH1": "Select Game",
		"FiltersH2": "Filters",
		"MobileCancelButtonText": "Cancel",
		"MobileCancelButtonTitleAttribute": "Cancel",
		"MobileFilterButtonText": "Game",
		"MobileFilterButtonTitleAttribute": "Game",
		"MobileSearchButtonText": "Change",
		"MobileSearchButtonTitleAttribute": "Change",
		"PageText1ValidWordDesktop": "is playable",
		"PageText1ValidWordMobile": "{UserQuery}",
		"PageText2ValidWord": "{QueryPoints}",
		"PageWordLengthHeaderContainer": "{numberQuery} Letter Words",
		"SearchButtonText": "Search",
		"SearchButtonTitleAttribute": "Search",
		"SearchScreenAndModuleH1": "Unscramble Letters",
		"SortH2": "Sort All Results",
		"SortWordLength": "Word Length"
	},
	"WordsByNumberPage": {
		"H1": "{numberQuery} Letter Words",
		"MetaDescription": "Find all {numberQuery} letter words. Discover custom word lists to help you dominate your favorite word games. Get the words, score and win!",
		"MetaTitle": "{numberQuery} Letter Words | WordFinder®"
	},
	"WordsEndsLength": {
		"DetailPageH1": "{numberQuery} Letter Words Ending in {EndQuery}",
		"DetailPageMetaDescription": "Find all {numberQuery} letter words ending in {EndQuery}. Defeat any word game with the ultimate {numberQuery} letter word list that end in {EndQuery}, plus points for Scrabble and Words With Friends.",
		"DetailPageMetaDescriptionWithWordle": "Get all the 5-letter words ending in {EndQuery} you need on WordFinder. This complete list of five-letter words that end in {EndQuery} is perfect for Wordle, Scrabble and more.",
		"DetailPageMetaTitle": "{numberQuery} Letter Words Ending in {EndQuery} | WordFinder®",
		"DetailPageTableHeadingWordLength": "{numberQuery} Letter Words Ending in {EndQuery}",
		"DetailPageText": "<strong>{LengthQuery} letter words that end in {EndsQuery}</strong> are a great way to crush the competition in Scrabble® or Words With Friends®. Go ahead and check the definitions of the highest-scoring {EndsLink} and {LengthLink} too. And, don't forget to look at {LengthStartsLink} and all the {LengthContainLink}.",
		"DetailPageTextWithWordle": "<strong>Five letter words that end in {EndsQuery}</strong> can help you solve the difficult <a href='/wordle/'>Wordle</a> that's been giving you trouble. This extensive list of 5 letter words ending in {EndsQuery} can help you rack up points and snag bonuses in Scrabble® GO and Words With Friends® too. Don't forget to look at {LengthStartsLink} and all the {LengthContainLink}.",
		"DetailPageUrl": "https://wordfinder.yourdictionary.com/letter-words/NUMBER-ends-VALUE/"
	},
	"WordsWithDetailPageInternalLinks": {
		"Text1": "{RelatedWordListH1}",
		"Text2": "{RelatedWordListH1}",
		"TitleAttribute1": "{RelatedWordListH1} List",
		"TitleAttribute2": "{RelatedWordListH1} List",
		"Url1": "{RelatedWordListUrl}",
		"Url2": "{RelatedWordListUrl}"
	},
	"WordsStartingDetailPageInternalLinks": {
		"Text1": "{RelatedWordListH1}",
		"Text2": "{RelatedWordListH1}",
		"TitleAttribute1": "{RelatedWordListH1} List",
		"TitleAttribute2": "{RelatedWordListH1} List",
		"Url1": "{RelatedWordListUrl}",
		"Url2": "{RelatedWordListUrl}"
	},
	"WordsEndingDetailPageInternalLinks": {
		"Text1": "{RelatedWordListH1}",
		"Text2": "{RelatedWordListH1}",
		"TitleAttribute1": "{RelatedWordListH1} List",
		"TitleAttribute2": "{RelatedWordListH1} List",
		"Url1": "{RelatedWordListUrl}",
		"Url2": "{RelatedWordListUrl}"
	},
	"WordsLengthDetailPageInternalLinks": {
		"Text1": "{RelatedWordListH1}",
		"Text2": "{RelatedWordListH1}",
		"TitleAttribute1": "{RelatedWordListH1} List",
		"TitleAttribute2": "{RelatedWordListH1} List",
		"Url1": "{RelatedWordListUrl}",
		"Url2": "{RelatedWordListUrl}"
	},
	"EsScrabbleResultsPage": {},
	"AboutPageMetaDescription": "WordFinder by YourDictionary is the resource word game fans trust to help them win. Learn all about how we got started, our mission and our team in this overview.",
	"AboutPageMetaTitle": "About WordFinder by YourDictionary: Who We Are and What We Do",
	"AnagramSolverResultsMetaDescription": "Don't get half an answer to a whole question. With WordFinder's true anagram solver, no letter goes overlooked. Solve your troublesome anagrams in no time!",
	"AnagramSolverResultsMetaTitle": "Anagram Solver - Decode & Find All Solutions | WordFinder®",
	"AnagramadorIndexPageFirstH2": "What is an anagram?",
	"AppAboutPageMetaDescription": "Looking for a free cheat for Words With Friends®? Need help unscrambling Scrabble® tiles? Want an anagram finder for Word Chums® or Wordscapes®?",
	"AppAboutPageMetaTitle": "WordFinder App: Free Anagram Solver & Unscramble Cheat",
	"BurgerMenuAriaLabel": "Main Menu",
	"BurgerMenuLabel": "Menu",
	"CharacterLengthWordsText": "{numberQuery} Letter Words",
	"CodycrossAnswersAdvancedSearchText": "Crossword Letters",
	"EnWfLogoUrl": "https://wordfinder.yourdictionary.com",
	"EsWfLogoAltText": "WordFinder in Spanish | Buscador de palabras",
	"EsWfLogoAriaLabel": "WordFinder in Spanish Logo | Buscador de palabras",
	"EsWfLogoText": "Spanish",
	"EsWfLogoTitleAttribute": "WordFinder in Spanish | Buscador de palabras",
	"EsWfLogoUrl": "https://es.yourdictionary.com/buscador-de-palabras/",
	"ExcludesPlaceholder": "Excludes",
	"ExcludesTooltip": "Find Wordle words that do not contain any of these letters (up to {CharLimit}).",
	"GameCheatsPageMetaDescription": "List of game cheats for the most popular word games and letter puzzles. Unscramble, rearrange and discover playable words instantly. Always free to use.",
	"GameCheatsPageMetaTitle": "Game Cheats and Solvers for Word Games | Word Finder",
	"GetTheAppPageMetaDescription": "Looking for a free cheat for Words With Friends®? Need help unscrambling Scrabble® tiles? Want an anagram finder for Word Chums® or Wordscapes®?",
	"GetTheAppPageMetaTitle": "Get the WordFinder® App",
	"IncludesPlaceholder": "Includes",
	"IncludesTooltip": "Find Wordle words that include these letters (up to {CharLimit}) in any order.",
	"InternalLinksTitle": "Related Content",
	"JumbleSolverAdvancedSearchText": "Puzzle Letters",
	"JumbleSolverFirstH2": "Solve Jumbled Words",
	"LanguageSwitcherEnText": "English",
	"LanguageSwitcherEsText": "Spanish",
	"LegalInfoPageMetaDescription": "WordFinder's App Privacy Policy",
	"LegalInfoPageMetaTitle": "Privacy Policy",
	"LetterAndLetterH1": "Words with {letterQuery}",
	"LetterAndLetterPageBody": "When you have a {letterQuery} and are unsure of what word to play, check out this list and find a winner.",
	"LinksWordListsNLettersContaining": "{num} letter words containing",
	"LinksWordListsNLettersEnding": "{num} letter words ending in",
	"LinksWordListsNLettersStarting": "{num} letter words starting with",
	"LinksWordListsNLettersTitle": "Popular {num} letter word lists",
	"LogoAriaLabel": "WordFinder by YourDictionary",
	"LogoTitleAttribute": "WordFinder by YourDictionary",
	"LogoUrl": "https://wordfinder.yourdictionary.com",
	"MobileBurgerMenuAriaLabel": "Menu",
	"MobileBurgerMenuTitleAttribute": "Menu",
	"NumberAndLetterH1": "{numberQuery} Letter Words with {letterQuery}",
	"NumberAndLetterPageBody": "When you are looking for {numberQuery} letter words with {letterQuery} and can't find what you need, check out this list and find a winning word.",
	"QNotUH1": "Q Words Without U",
	"QNotUH2": "Q Words Without U",
	"QuordleSolverResultsMetaDescription": "Feeling stuck on today's Quordle? Find all four daily Quordle answers with some help from WordFinder's solver tool.",
	"QuordleSolverResultsMetaTitle": "Quordle Solver: Get Help with Today’s Quordle | WordFinder®",
	"ResultTableTextWordsShown": "Showing {ShownWords} of {TotalWords} words",
	"ResultTableTextWordsShownMobile": "{ShownWords} of {TotalWords} words",
	"SeeAllButtonText": "See All Words",
	"SeeLessButtonText": "See Fewer Words",
	"SeeMoreButtonText": "See More Words",
	"SuggestedLinksSimpleWordLists": "{Prefix} {UserQuery} can help you score big playing Words With Friends® and Scrabble®. Having a list of words with a specific letter, or combination of letters, could be what you need to decide your next move and gain the advantage over your opponent. While you’re at it, don’t forget to look at {FirstLink} and {SecondLink}. YourDictionary’s Word Finder provides you with words to focus on, each with the point counts for Scrabble® and Words With Friends®.",
	"TextTwistAdvancedSearchText": "Block Letters",
	"WordConnectAnswersAdvancedSearchText": "Block Letters",
	"WordUnscramblerH1": "Word Unscrambler",
	"WordUnscramblerMetaDescription": "Unscramble words and letters with our free word unscrambler. Ideal for solving jumbled words and anagrams, or finding the perfect unscramble words cheat.",
	"WordUnscramblerMetaTitle": "Word Unscrambler - Quickly Unscramble Words and Letters (Quick Cheats) - Word Finder",
	"WordleAnswersMetaDescription": "Reveal today’s Wordle answer and every Wordle word before it with this comprehensive list of past Wordle solutions. Find daily Wordle answers for any date.",
	"WordleAnswersMetaTitle": "List of Past Wordle Answers & Archive (Updated Daily)",
	"WordleHintsMetaDescription": "Think some Wordle hints might help you guess today’s word in three tries or less? Give it a go with our helpful hints!",
	"WordleHintsMetaTitle": "Wordle Hints & Answer for Today ({MonthDay})",
	"WordleSolverResultsMetaDescription": "Stuck on today’s Wordle answer? Use WordFinder’s helper tool to win at 2022’s most viral word game. Be the first to guess Wordle’s word of the day!",
	"WordleSolverResultsMetaTitle": "Wordle Solver - Get Help With Today’s Wordle | WordFinder®",
	"WordsEndingPageH1": "Words Ending in {letterQuery}",
	"WordsEndingPageMetaDescription": "Find all words ending in {EndQuery}. Defeat any word game when you know the best words. Get a custom list with words that end in the letter you need!",
	"WordsEndingPageMetaTitle": "Words Ending in {EndQuery} | WordFinder®",
	"WordsStartingPageH1": "Words Starting with {letterQuery}",
	"WordsStartingPageMetaDescription": "Find all words that start with {StartQuery}. Uncover more words to raise your score and win with the right word list! Find winning combinations here.",
	"WordsStartingPageMetaTitle": "Words That Start With {StartQuery} | WordFinder®",
	"WordsWithPageH1": "Words Containing the Letter {letterQuery}",
	"WordsWithPageMetaDescription": "Find all words with {ContainQuery}. Earn more points in your favorite word games by getting the winning words you need from this list!",
	"WordsWithPageMetaTitle": "Words With {ContainQuery} | WordFinder®",
	"YdrLogoText": "Dictionary"
};

module.exports = en;
